export default __webpack_public_path__ + "static/media/computers.765c2138.svg";